'use strict';

angular.module('pmtPlacesApp.controllers').controller('SpecialHoursCtrl', [
	'$scope',
	'$stateParams',
	'$timeout',
	'$http',
	'$location',
	'auth',
	'Upload',
	'pmtAlertService',
	'$i18next',
	function (
		$scope,
		$stateParams,
		$timeout,
		$http,
		$location,
		auth,
		Upload,
		pmtAlertService,
		$i18next
	) {
		let site = $stateParams.site;
		const importStates = Object.freeze({
			NotSet: 'NotSet',
			Uploading: 'Uploading',
			Success: 'Success',
			Error: 'Error'
		});
		$scope.updateManyLocations = $i18next.t('listings.special_open_hours.update_many_locations', {
			specialHours: '<strong>' + $i18next.t('general.location_special_hours') + '</strong>'
		});

		$scope.site = site;
		$scope.progressPercentage = 0;
		$scope.showUploadingProgress = false;
		$scope.showImportProgress = false;
		$scope.userIsAdmin = auth.user.isAdmin;
		$scope.googleImport = false;
		$scope.googleImportStatus = '';
		$scope.templateHelp = false;
		$scope.includePastDates = false;
		$scope.importState = importStates.NotSet;

		$scope.openSet = false;

		$scope.getHoursToCsvUrl = () => {
			return `api/${encodeURI(site)}/export/openinghours/csv?includePastDates=${
				$scope.includePastDates ? 'true' : ''
			}`;
		};
		$scope.getHoursToSpreadsheetUrl = () => {
			return `api/${encodeURI(site)}/export/openinghours/xlsx?includePastDates=${
				$scope.includePastDates ? 'true' : ''
			}`;
		};

		$scope.toggleIncludePastDates = () => {
			$scope.includePastDates = !$scope.includePastDates;
			console.log($scope.getHoursToSpreadsheetUrl());
			console.log($scope.getHoursToCsvUrl());
		};

		$scope.upload = function (files) {
			if (files && files.length) {
				let start = new Date().getTime();

				$scope.showUploadingProgress = true;

				let file = files[0];
				$scope.uploadingFile = file.name;

				$scope.progressPercentage = 0;
				$scope.importData = null;
				$scope.uploadError = null;
				Upload.upload({ url: 'api/' + site + '/import/specialhours/validate', file: file })
					.progress(function (evt) {
						$scope.progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
					})
					.success(function (data) {
						if (data.success) {
							$http.get('api/' + site + '/places').then(function (places) {
								let end = new Date().getTime();
								let totalTime = end - start;
								let minTimeToShow = 2500; // milisec
								let delay = 0;
								if (totalTime < minTimeToShow) {
									delay = minTimeToShow - totalTime;
								}
								$timeout(function () {
									$scope.uploadingFile = '';
									$scope.showUploadingProgress = false;
									$scope.places = places.data;
									$scope.importData = data.data;
								}, delay);
							});
						} else {
							$scope.uploadError = data.data;
							$scope.showUploadingProgress = false;
						}
					})
					.error(function () {
						$scope.showUploadingProgress = false;
					});
			}
		};

		function prepareUserForPinMeToPage(user) {
			const localAccess = { ...user.localAccess };
			localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
			localAccess.permissions = localAccess.permissions
				? [...localAccess.permissions.values()]
				: [];
			return {
				...user,
				localAccess: localAccess
			};
		}

		auth.getUser($stateParams.site).then(async user => {
			$scope.args = {
				user: prepareUserForPinMeToPage(user),
				today: new Date().toISOString()
			};
		});

		$scope.openSetDialog = function () {
			$scope.openSet = true;
		};

		$scope.closeSetDialog = function () {
			$scope.openSet = false;
		};

		$scope.cancelImport = function () {
			$scope.importData = null;
			$scope.uploadError = null;
			$scope.progressPercentage = 0;
		};

		$scope.confirmImport = function () {
			$scope.showImportProgress = true;
			$scope.importState = importStates.Uploading;
			$http
				.post('api/' + site + '/import/specialhours/confirm', $scope.importData)
				.then(function (data) {
					$scope.importState = importStates.Success;
					$scope.importedHours = data.data.data;
				})
				.catch(function (err) {
					$scope.importState = importStates.Error;
					$scope.showImportProgress = false;

					let alertBody;

					if (err.status === 502) {
						alertBody = $i18next.t('listings.special_open_hours.import_timeout');
					} else {
						alertBody = err.data && err.data.message ? err.data.message : err.toString();
					}

					pmtAlertService.alert({
						title: $i18next.t('listings.special_open_hours.import_failed'),
						body: alertBody,
						confirmTitle: $i18next.t('general.ok'),
						confirm: function () {
							pmtAlertService.close();
						}
					});
				});
		};

		$scope.closeImportProgress = function () {
			$scope.showImportProgress = false;
			$scope.importedHours = 0;
			$location.path('/' + site + '/tasks');
		};

		let importFromGoogle = function () {
			pmtAlertService.close();
			$scope.googleImportStatus = $i18next.t('listings.special_open_hours.updating_from_google');
			$scope.googleImport = true;
			$http
				.post('api/' + site + '/import/specialhours/google/update')
				.then(function () {
					$scope.googleImportStatus = $i18next.t('listings.special_open_hours.setting_data');
					return $http.post('api/' + site + '/import/specialhours/google/apply');
				})
				.then(() => {
					pmtAlertService.alert({
						title: $i18next.t('listings.special_open_hours.import_done'),
						body: $i18next.t('listings.special_open_hours.successful_import_google'),
						confirmTitle: $i18next.t('general.ok'),
						confirm: function () {
							pmtAlertService.close();
						}
					});
				})
				.catch(err => {
					pmtAlertService.alert({
						title: $i18next.t('listings.special_open_hours.import_failed'),
						body: err.data?.message || 'Import failed',
						confirmTitle: $i18next.t('general.ok'),
						confirm: function () {
							pmtAlertService.close();
						}
					});
				})
				.finally(() => ($scope.googleImport = false));
		};

		$scope.importFromGoogle = function () {
			pmtAlertService.alert({
				title: $i18next.t('listings.special_open_hours.import_special_hours'),
				body: $i18next.t('listings.special_open_hours.confirm_google_import'),
				confirmTitle: $i18next.t('general.yes'),
				cancelTitle: $i18next.t('general.no'),
				confirm: importFromGoogle,
				cancel: function () {
					pmtAlertService.close();
				}
			});
		};
	}
]);
